/**
 * adminStyles.js — shared AdminScreen StyleSheet (god-file decomposition).
 * Verbatim move from AdminScreen.jsx; used by the shell and extracted tabs.
 */

import { StyleSheet, Platform } from 'react-native';

export const adminStyles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#0b0b0b' },
  
  // Main layout with sidebar
  mainLayout: {
    flex: 1,
    flexDirection: 'row',
  },
  
  // Sidebar styles
  sidebar: {
    width: 240,
    backgroundColor: '#111',
    borderRightWidth: 1,
    borderRightColor: 'rgba(255,255,255,0.08)',
  },
  sidebarCollapsed: {
    width: 64,
  },
  sidebarMobile: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 100,
    width: 280,
  },
  sidebarHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.08)',
  },
  sidebarHeaderCollapsed: {
    justifyContent: 'center',
    paddingHorizontal: 12,
  },
  sidebarTitle: {
    color: '#fff',
    fontSize: 18,
    fontWeight: '700',
  },
  closeSidebarBtn: {
    padding: 4,
  },
  collapseBtn: {
    padding: 6,
    borderRadius: 6,
    backgroundColor: 'rgba(255,255,255,0.05)',
  },
  sidebarNav: {
    flex: 1,
  },
  navGroup: {
    paddingVertical: 12,
    paddingHorizontal: 12,
  },
  navGroupBorder: {
    borderTopWidth: 1,
    borderTopColor: 'rgba(255,255,255,0.06)',
  },
  navGroupTitle: {
    color: 'rgba(255,255,255,0.4)',
    fontSize: 11,
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: 8,
    paddingHorizontal: 8,
  },
  navGroupLabs: {
    marginHorizontal: 8,
    marginVertical: 4,
    paddingVertical: 10,
    paddingHorizontal: 8,
    borderRadius: 10,
    backgroundColor: 'rgba(162, 89, 255, 0.08)',
    borderWidth: 1,
    borderColor: 'rgba(162, 89, 255, 0.22)',
  },
  navGroupTitleLabs: {
    color: '#c4b5fd',
  },
  navItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 8,
    marginBottom: 2,
  },
  navItemCollapsed: {
    justifyContent: 'center',
    paddingHorizontal: 0,
  },
  navItemActive: {
    backgroundColor: 'rgba(167, 139, 250, 0.15)',
  },
  navItemText: {
    color: 'rgba(255,255,255,0.7)',
    fontSize: 14,
    fontWeight: '500',
  },
  navItemTextActive: {
    color: '#a78bfa',
    fontWeight: '600',
  },
  sidebarFooter: {
    padding: 12,
    borderTopWidth: 1,
    borderTopColor: 'rgba(255,255,255,0.06)',
    marginTop: 12,
  },
  sidebarFooterCollapsed: {
    padding: 8,
  },
  backHomeBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 8,
    backgroundColor: 'rgba(255,255,255,0.05)',
  },
  backHomeBtnCollapsed: {
    justifyContent: 'center',
    paddingHorizontal: 0,
  },
  backHomeBtnText: {
    color: 'rgba(255,255,255,0.7)',
    fontSize: 14,
    fontWeight: '500',
  },
  
  // Content area
  contentArea: {
    flex: 1,
    backgroundColor: '#0b0b0b',
  },
  mobileTopBar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 12,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.08)',
  },
  menuBtn: {
    padding: 8,
  },
  mobileTitle: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
  body: { flex: 1, padding: 16 },
  
  // Sidebar overlay for mobile
  sidebarOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    zIndex: 99,
  },
  tabWrap: { flex: 1 },
  sectionTitle: { color: '#fff', fontSize: 18, fontWeight: '700', marginBottom: 12 },
  row: { flexDirection: 'row', alignItems: 'center', gap: 10, marginBottom: 12 },
  label: { color: 'rgba(255,255,255,0.9)', width: 100 },
  input: { flex: 1, height: 40, paddingHorizontal: 10, borderRadius: 8, borderWidth: 1, borderColor: 'rgba(255,255,255,0.18)', color: '#fff' },
  btn: { paddingVertical: 10, paddingHorizontal: 12, borderRadius: 8, backgroundColor: '#ffffff', alignItems: 'center' },
  btnText: { color: '#000', fontWeight: '700' },
  outputBox: { flex: 1, backgroundColor: 'rgba(255,255,255,0.04)', borderRadius: 8, padding: 12, borderWidth: 1, borderColor: 'rgba(255,255,255,0.1)' },
  outputText: { color: 'rgba(255,255,255,0.85)', fontFamily: Platform.OS === 'web' ? 'monospace' : undefined, whiteSpace: Platform.OS === 'web' ? 'pre-wrap' : undefined },
  userRow: { flexDirection: 'column', alignItems: 'stretch', gap: 10, paddingVertical: 10, paddingHorizontal: 12, borderRadius: 8, borderWidth: 1, borderColor: 'rgba(255,255,255,0.10)', marginBottom: 8 },
  userRowMobile: { flexDirection: 'column', alignItems: 'stretch', paddingVertical: 12 },
  userEmail: { color: '#fff', fontWeight: '600' },
  userMeta: { color: 'rgba(255,255,255,0.7)', fontSize: 13 },
  userActions: { flexDirection: 'row', gap: 8, flexWrap: 'wrap', maxWidth: '100%' },
  actionGroupLabel: { color: 'rgba(255,255,255,0.6)', fontSize: 12, fontWeight: '600', marginBottom: 6, textTransform: 'uppercase' },
  smallBtn: { paddingVertical: 8, paddingHorizontal: 10, borderRadius: 8, backgroundColor: 'rgba(255,255,255,0.14)' },
  smallBtnMobile: { paddingVertical: 6, paddingHorizontal: 8 },
  smallBtnText: { color: '#fff', fontWeight: '600', fontSize: 12 },
  
  // Mobile Dropdown Styles
  mobileDropdownGroup: {
    marginBottom: 8,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.12)',
    backgroundColor: 'rgba(255,255,255,0.04)',
    overflow: 'hidden',
  },
  mobileDropdownHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 12,
    backgroundColor: 'rgba(255,255,255,0.06)',
  },
  mobileDropdownHeaderText: {
    color: '#fff',
    fontSize: 13,
    fontWeight: '600',
  },
  mobileDropdownArrow: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: 12,
  },
  mobileDropdownContent: {
    backgroundColor: 'rgba(255,255,255,0.02)',
  },
  mobileDropdownItem: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderTopWidth: 1,
    borderTopColor: 'rgba(255,255,255,0.08)',
  },
  mobileDropdownItemText: {
    color: '#fff',
    fontSize: 13,
    fontWeight: '500',
  },
  hintText: { color: 'rgba(255,255,255,0.8)' },
  caption: { color: 'rgba(255,255,255,0.7)', marginTop: 8 },
  groupHeader: { color: 'rgba(255,255,255,0.9)', fontWeight: '700', marginTop: 12, marginBottom: 6 },
  card: { padding: 12, borderRadius: 10, borderWidth: 1, borderColor: 'rgba(255,255,255,0.12)', backgroundColor: 'rgba(255,255,255,0.03)', marginBottom: 12 },
  tag: { paddingVertical: 6, paddingHorizontal: 10, borderRadius: 14, borderWidth: 1, borderColor: 'rgba(255,255,255,0.18)' },
  tagActive: { backgroundColor: 'rgba(255,255,255,0.18)', borderColor: 'rgba(255,255,255,0.28)' },
  tagText: { color: 'rgba(255,255,255,0.85)', fontWeight: '600' },
  tagTextActive: { color: '#000' },
  link: { color: '#9fd3ff', textDecorationLine: 'underline' },
  betRow: { flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 10, paddingHorizontal: 12, borderRadius: 8, borderWidth: 1, borderColor: 'rgba(255,255,255,0.10)' },
  betMain: { color: '#fff', fontWeight: '700' },
  betMeta: { color: 'rgba(255,255,255,0.7)' }
});
